// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__d2N9U","label":"Checkbox_label__58KeY","disabled":"Checkbox_disabled__SiYgR","checkboxText":"Checkbox_checkboxText__YyUgf"};